/**
 * Algolia-powered autocomplete for the Globber fast-search form.
 *
 * Replaces the default WP-AJAX search handler with a direct Algolia REST query
 * when window.glbrAlgolia is present. Renders product hits (image, title, price)
 * into the existing .fast-search__helper-container.
 */
(function ($) {
    'use strict';

    if (
        typeof window.glbrAlgolia === 'undefined' ||
        !window.glbrAlgolia.appId ||
        !window.glbrAlgolia.searchKey ||
        !window.glbrAlgolia.indexName
    ) {
        return;
    }

    var cfg = window.glbrAlgolia;

    var ALGOLIA_URL =
        'https://' + cfg.appId + '-dsn.algolia.net/1/indexes/' +
        encodeURIComponent(cfg.indexName) + '/query';

    /**
     * Query the Algolia products index directly via REST.
     */
    function algoliaSearch(query) {
        return fetch(ALGOLIA_URL, {
            method: 'POST',
            headers: {
                'X-Algolia-Application-Id': cfg.appId,
                'X-Algolia-API-Key':        cfg.searchKey,
                'Content-Type':             'application/json',
            },
            body: JSON.stringify({
                query:                 query,
                hitsPerPage:           8,
                attributesToHighlight: ['title'],
                highlightPreTag:       '<em>',
                highlightPostTag:      '</em>',
                attributesToRetrieve:  ['title', 'permalink', 'image', 'price', 'regular_price', 'sale_price', 'on_sale'],
            }),
        }).then(function (r) { return r.json(); });
    }

    /** Minimal HTML escaping for untrusted strings. */
    function esc(str) {
        return String(str || '')
            .replace(/&/g, '&amp;')
            .replace(/</g, '&lt;')
            .replace(/>/g, '&gt;')
            .replace(/"/g, '&quot;');
    }

    /** Format a numeric price for display. */
    function formatPrice(val) {
        if (val === null || val === undefined || val === '') return '';
        return parseFloat(val).toFixed(2);
    }

    /**
     * Build the price HTML for a hit.
     * Shows strike-through regular price + sale price when on sale.
     */
    function priceHtml(hit) {
        if (!hit.price && hit.price !== 0) return '';

        if (hit.on_sale && hit.regular_price && hit.sale_price !== null) {
            return (
                '<span class="search-hit__price search-hit__price--sale">' +
                    '<del>' + formatPrice(hit.regular_price) + '</del>' +
                    ' <ins>' + formatPrice(hit.sale_price) + '</ins>' +
                '</span>'
            );
        }

        return '<span class="search-hit__price">' + formatPrice(hit.price) + '</span>';
    }

    /**
     * Render Algolia hits into the dropdown container.
     * Uses the existing .prompt-search-dropdown CSS structure with product extensions.
     */
    function renderHits(hits, query, $container) {
        if (!hits || !hits.length) {
            $container.html(
                '<div class="prompt-search-dropdown custom-scroll">' +
                '<p class="prompt-search-dropdown__title">No results for &ldquo;' + esc(query) + '&rdquo;</p>' +
                '</div>'
            );
            return;
        }

        var items = hits.map(function (hit) {
            var title = (
                hit._highlightResult &&
                hit._highlightResult.title &&
                hit._highlightResult.title.value
            ) ? hit._highlightResult.title.value : esc(hit.title);

            var img = hit.image
                ? '<img class="search-hit__img" src="' + esc(hit.image) + '" alt="' + esc(hit.title) + '" loading="lazy" />'
                : '<span class="search-hit__img search-hit__img--placeholder"></span>';

            return (
                '<li>' +
                '<a class="prompt-search-dropdown__item search-hit" href="' + esc(hit.permalink) + '">' +
                    img +
                    '<span class="search-hit__details">' +
                        '<span class="search-hit__title">' + title + '</span>' +
                        priceHtml(hit) +
                    '</span>' +
                '</a>' +
                '</li>'
            );
        }).join('');

        $container.html(
            '<div class="prompt-search-dropdown custom-scroll">' +
            '<p class="prompt-search-dropdown__title">Results for &ldquo;' + esc(query) + '&rdquo;</p>' +
            '<ul>' + items + '</ul>' +
            '</div>'
        );
    }

    // Remove the WP-AJAX handler and wire up the Algolia one.
    $(document).off('input', '.js-search-form .fast-search__input');

    var debounceTimer;

    $(document).on('input', '.js-search-form .fast-search__input', function () {
        var value   = $(this).val();
        var $form   = $(this).closest('.js-search-form');
        var $helper = $form.find('.fast-search__helper-container');

        clearTimeout(debounceTimer);

        if (value.trim().length < 3) {
            $helper.empty();
            return;
        }

        $form.addClass('loading');

        debounceTimer = setTimeout(function () {
            algoliaSearch(value)
                .then(function (data) {
                    $form.removeClass('loading');
                    renderHits(data.hits, value, $helper);
                })
                .catch(function () {
                    $form.removeClass('loading');
                });
        }, 200);
    });

})(jQuery);
